export default {
  fastRegistration: 'Швидка реєстрація',
  userEnter: 'вхід для клієнтів',
  contacts: 'контакти',
  findOutTheCost: 'Дізнатися вартість',
  brand: 'SOVTES',
  register: 'Зареєструватися',

  metaTags: {
    metaTitle:
      'Sovtes — онлайн логістика, управління вантажоперевезеннями, еттн, веб-програма',
    metaDecription:
      'Sovtes — веб-програма з контролю вантажоперевезень. дозволяє ефективно управляти вантажними перевезеннями за рахунок автоматизації логістичних процесів. реєстрація електронної товаро-транспортної накладної, еттн',
    metaKeywords:
      'вантажоперевезення, вільні маршрути для перевізників, онлайн логістика, програма sovtes, совтес, еттн',
    ttnDescription:
      'Дозволяє зареєструвати електронну товаро-транспортну накладну онлайн безкоштовно з цифровим підписом в Україні, додати еттн',
    ttnKeywords:
      'Реєстрація ТТН онлайн безкоштовно, еТТН, електронна товаро транспортна накладна з цифровим підписом, програма Sovtes, Совтес, еттн',
    ttnTitle:
      'Реєстрація ТТН онлайн безкоштовно в Україні, еТТН, eTTN - Sovtes',
    thankyouTitle: 'Дякую - Sovtes',
    thankyou2Title: 'Дякую2 - Sovtes',
    thankyou3Title: 'Дякую3 - Sovtes',
    thankyou4Title: 'Дякую4 - Sovtes',
    thankyou5Title: 'Дякую5 - Sovtes',
    thankyou6Title: 'Дякую6 - Sovtes',
  },
  nav: {
    links: {
      1: 'про продукт',
      5: 'аудит',
      2: 'перевізнику',
      3: 'замовнику',
      4: 'ціна',
    },
  },
  sectionMain: {
    msg1: 'до 25% реальної економії',
    msg2: 'на вантажоперевезеннях',
    registration: 'Реєстрація',
    knowMore: 'Дізнатися більше про продукт',
    thankyou1: 'Дякуємо! Найближчим часом ми з вами зв’яжемося',
    thankyou2: 'Дякуємо! Найближчим часом ми з вами зв’яжемося',
    thankyou3: 'Дякуємо! Найближчим часом ми з вами зв’яжемося',
    thankyou4: 'Дякуємо! Найближчим часом ми з вами зв’яжемося',
    thankyou5: 'Дякуємо! Найближчим часом ми з вами зв’яжемося',
    thankyou6: 'Дякуємо! Найближчим часом ми з вами зв’яжемося',
    ettn1: 'Дякуємо за підписання еТТН.',
    ettn2: 'Для продовження натисніть на синю кнопку «ЕТТН підписано» нижче',
    ttn1: 'Реєстрація еТТН безкоштовно: електронні ТТН в Україні',
    ttn2: 'Реєструйтеся і ми Вас підключимо до еТТН',
  },
  sectionSlogan: {
    msg1: 'Ваша основна система управління автотранспортною логістикою',
    msg2: 'це SaaS-рішення для вигідного управління вантажоперевезеннями',
  },
  sectionPositions: {
    list: {
      1: 'простота',
      2: 'ефективність',
      3: 'доступність',
    },
    msg1:
      'Дізнайтеся, як вирішити логістичні проблеми бізнесу, який використовує найманий автотранспорт для доставки вантажу. На ваш email ми надішлемо безкоштовну презентацію, спеціально розроблену нашими експертами.',
  },
  sectionAudit: {
    title: 'аудит тарифів на перевезення',
    footer: {
      txt1: 'ТОВ Совтес є одним з',
      link:
        '7 затверджених постачальників електронної товаро-транспортної накладної України.',
      txt2:
        'Підключайтеся до центрального реєстру ЕТТН за допомогою затвердженого постачальника',
    },
  },
  sectionAdvantages: {
    title: 'переваги',
    shipper: 'Замовнику',
    transporter: 'Перевізнику',
    lists: {
      transporter: {
        11: {
          label: 'Актуальні замовлення',
          description:
            'Sovtes співпрацює тільки з прямими замовниками, виключає можливість дублювання замовлень на перевезення.',
        },
        12: {
          label: 'Вигідне партнерство',
          description:
            'Ставши партнером Sovtes, ви отримуєте доступ до всіх заявок наших клієнтів без необхідності укладення додаткових договорів.',
        },
        13: {
          label: 'Швидкі контракти',
          description:
            'Замовлення в Sovtes містить всі необхідні дані про перевезення. Досить запропонувати транспортний засіб і підписати заявку, яка формується автоматично. Ніяких дзвінків.',
        },
        14: {
          label: 'Швидка оплата',
          description:
            'Оформлюючи перевезення через Sovtes, ви гарантовано отримуєте оплату за здійснене перевезення протягом 10 днів після розвантаження.',
        },
        15: {
          label: 'Нові клієнти',
          description:
            'Ми постійно працюємо над залученням нових замовників транспортних послуг, вам необхідно лише вибрати, з ким і на яких умовах працювати.',
        },
        16: {
          label: 'Зменшення витрат',
          description:
            "Простій і порожні пробіги з'їдають ваш прибуток. Ми пропонуємо зменшити кількість простоїв і порожніх поїздок за рахунок доступу до більшої кількості актуальних заявок на перевезення.",
        },
      },
      shipper: {
        21: {
          label: 'Швидкий запуск',
          description:
            'Повний запуск системи на підприємстві відбувається менш ніж за 5 днів.',
        },
        22: {
          label: 'Економія',
          description:
            'Система SOVTES гарантовано знижує витрати на автоперевезення на 22% -25%.',
        },
        23: {
          label: 'Звітність',
          description:
            'Автоматичні своєчасні і достовірні звіти по вашим угодам.',
        },
        24: {
          label: 'Швидкість',
          description:
            'Пошук потрібного транспорту відбувається за лічені хвилини.',
        },
        25: {
          label: 'Електронний документообіг',
          description:
            'Максимально спрощуйте і прискорюйте свою роботу з перевізниками.',
        },
        26: {
          label: 'Інтеграція',
          description:
            'Автоматизований обмін даними з різними ERP-системами вашого бізнесу.',
        },
      },
    },
  },
  partners: {
    title: 'партнери',
    subTitle: 'Тільки для клієнтів системи Sovtes:',
    list: {
      1: {
        description:
          'Перші два місяці використання сервісу «Вчасно» безкоштовно',
      },
      2: {
        description:
          'Співзасновник Sovtes Олег Рудковський є головою комітету з транспорту і логістики СУП (Спілка Українських Підприємців)',
      },
    },
  },
  clientsSection: {
    title: 'клієнти',
    list: {
      1: {
        name: 'Олексій Нодь',
        rank: 'Керівник відділу транспортної логістики МЧП "АТ"',
        comment:
          'З командою ми співпрацюємо з 2014 року. Хочемо висловити Sovtes подяку за створення ефективного  продукту, що постійно розвивається! Завдяки вашому порталу ми здобули нових партнерів по бізнесу, значно скоротили час на обробку заявок і забезпечили транспорт постійними завантаженнями. Ми бажаємо подальшого процвітання проекту! Тільки вперед!',
      },
      2: {
        name: 'Анна Хватова',
        rank: 'Начальник відділу транспортної логістики ТОВ «ТД« Щедро »',
        comment:
          'Серед головних переваг варто відзначити можливість організації повної прозорості проведення тендерної процедури, а також економію коштів і часу на вирішення завдань. Для нашої компанії впровадження системи стало одним з найефективніших методів забезпечення добросовісної конкуренції та прозорості проведення закупівлі транспортних послуг.',
      },
      3: {
        name: 'Лілія КУШНАРЬОВА',
        rank:
          'Директор адміністративно-логістичного департаменту Global Spirits (ТМ «Хортиця»)',
        comment:
          'З SOVTES ми співпрацюємо понад рік. Це багатофункціональна інформаційна програма, яка забезпечує економію нашого часу і коштів. За допомогою SOVTES ви і ваші перевізники завжди будете володіти up-to-date інформацією. Платформа SOVTES - відрізняється зручністю використання і надійністю зберігання інформації. Рекомендуємо співпрацю!',
      },
    },
  },
  howItWorks: {
    title: 'як працює',
    list: {
      1: {
        label: 'Звітність',
        description:
          'Перелік даних, що зберігаються дозволяє складати необхідну звітність відповідно до вимог наших клієнтів. На замовлення клієнтів ми розробляємо персоналізовані звіти, система автоматично генерує і відправляє їх відповідній особі.',
      },
      2: {
        label: 'Документообіг',
        description:
          'Електронний документообіг і автоматичне створення документів дозволяють істотно підвищити рівень безпеки, виключити ризики втрати документів, знизити витрати на кореспонденцію до 99% і прискорити обмін документами до декількох хвилин.',
      },
      3: {
        label: 'Простота взаємодії',
        description:
          'Після публікації заявки всі перевізники миттєво і одночасно отримують інформацію про замовлення. Функціонал SOVTES забезпечує легкий обмін даними - як від замовника до перевізників, так і в зворотньому напрямку для швидкого оформлення угоди на перевезення.',
      },
      4: {
        label: 'Облік',
        description:
          'Всі дії і найважливіші показники зберігаються у надійно захищених базах даних. Можливість інтеграції через API забезпечує передачу необхідної інформації в ERP-системи наших клієнтів. Зберігання і передача даних повністю автоматизовані і не потребують людських ресурсів.',
      },
    },
  },
  aboutSection: {
    subTitle:
      'сервіс, який дозволить контролювати доставку вантажів на всіх етапах транспортування, отримувати актуальну статистику по вашим перевезенням і працювати з документацією.',
  },
  sectionPrice: {
    title1: 'вартість для замовника',
    msg1: 'залежить від кількості перевезень, яку ви здійснюєте за місяць.',
  },
  forms: {
    shipper: 'Я замовник',
    transporter: 'Я перевізник',
  },
  footer: {
    msg1: 'реєстрація ЕТТН онлайн',
    address: {
      city: '04112, м. Київ,',
      street: 'вул. Дорогожицька 3,',
      house: 'Unit City, B9, оф. 414',
    },
  },
}
